import React, { memo, useCallback } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import useIsVisible from './useIsVisible'

function AnimationCard({ id, name, preview, isSelected, onSelect: handleSelect }) {
  const [cardRef, isVisible] = useIsVisible()
  const handleClick = useCallback(() => handleSelect(id), [id, handleSelect])

  return (
    <button
      ref={cardRef}
      type="button"
      className={classnames(
        'animation-card',
        isSelected && 'animation-card--selected',
      )}
      onClick={handleClick}
      aria-pressed={isSelected}
    >
      {isVisible && (
        <img
          alt=""
          aria-hidden="true"
          className="animation-card__preview"
          src={preview}
        />
      )}
      <span className="animation-card__name cgt-body-base">{name}</span>
    </button>
  )
}

AnimationCard.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  preview: string.isRequired,
  isSelected: bool.isRequired,
  onSelect: func.isRequired,
}

export default memo(AnimationCard)
